export default "__VITE_ASSET__Fi7WjmNT__"